// extracted by mini-css-extract-plugin
export default {"container":"DropContainer_container__duqI4","dropArea":"DropContainer_dropArea__WGe42","active":"DropContainer_active__fk--X"};